import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { brand } from '@/config/brand';
import { BaselinePanel } from '@/components/BaselinePanel';
import { CatalogTable } from '@/components/CatalogTable';
import { FilterBar } from '@/components/FilterBar';
import { CATEGORY_LABELS } from '@/lib/catalog';
import { CATEGORY_INTROS } from '@/lib/categoryIntros';
import { useCatalog } from '@/hooks/CatalogContext';
import type { DrinkCategory } from '@/types/data';

export function CatalogPage({ category }: { category?: DrinkCategory }) {
  const {
    loading,
    error,
    filteredSorted,
    setFilters,
    filters,
  } = useCatalog();

  useEffect(() => {
    if (category && filters.category !== category) {
      setFilters({ category, subtype: null });
    }
  }, [category, filters.category, setFilters]);

  if (loading) return <p>Loading catalog…</p>;
  if (error) return <p role="alert">Could not load catalog: {error}</p>;

  const intro = category ? CATEGORY_INTROS[category] : null;

  return (
    <>
      <section className="hero">
        <p className="eyebrow">{brand.domain}</p>
        <h1>{intro?.title ?? brand.tagline}</h1>
        {intro ? (
          <p>{intro.body}</p>
        ) : (
          <p>
            Alcohol / 100 cal — leanest pour for the calories.
            <br />
            Alcohol / $ — most alcohol for the money.
            <br />
            Set a baseline to find drinks that are better on both calories and
            cost for the same alcohol. Read the{' '}
            <Link to="/guides/how-to-read-boozeratio-rankings/">rankings guide</Link>{' '}
            or browse all <Link to="/guides/">guides</Link>.
          </p>
        )}
      </section>

      <FilterBar lockedCategory={category} />
      <BaselinePanel />

      <p className="muted">
        Showing {filteredSorted.length} ·{' '}
        {CATEGORY_LABELS[category ?? filters.category]} · default sort alcohol /
        100 cal
      </p>

      <CatalogTable rows={filteredSorted} />
    </>
  );
}
